import axios from "axios";
import { checkStatus, getHeaders } from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;

export async function getAnnouncement(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Announcement/List`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }

export async function getAnnouncementYear(params) {
    try {
      const response = await axiosInstance.get(`${baseURL}/Org/Announcement/Years?OrgId=${params.OrgId}`, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }

export async function AddAnnouncement(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Announcement/AddAnnouncement`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }

//Delete Announcement
export const DeleteAnnouncement = async (body) => {
  try {
    const response = await axiosInstance.delete(`${baseURL}/Org/Announcement/DeleteAnnouncement`,{
      headers: await getHeaders(),
      data: body,
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}